import { Route } from '@angular/router';
import { NotificationsComponent } from 'src/app/pages/notifications/notifications.component';
import { RoutingID } from '../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const notifications: Route = {
  path: 'notifications',
  title: 'nav.notifications',
  data: {
    icon: SbIcons.bell,
    breadcrumb: 'nav.notifications',
    id: RoutingID.notification,
  },
  children: [
    {
      path: '',
      component: NotificationsComponent,
      data: {
        breadcrumb: '',
      },
    },
  ],
};
